module.exports = __webpack_public_path__ + "static/img/device_bg.06de504.png";